import React, { useState, useEffect } from 'react';

import Skeleton from './Skeleton';
import _ from 'lodash';
import { Flex } from '../../styles/globalStyles';

const vodRender = ['vod1', 'vod2', 'vod3', 'vod4'];

const VodListSkeleton = ({ wrap, list, boxWidth, boxHeight, display, listAdd, showCnt, oneData }) => {
  const [skelRender, setSkelRender] = useState([]);

  useEffect(() => {
    let skel = _.cloneDeep(vodRender);

    if (listAdd) skel.push('vod5');
    if (oneData) skel = ['vod1'];

    setSkelRender(skel);
  }, [listAdd]);

  return (
    <Flex justifyContent='space-between' flexWrap='wrap' style={{ width: '100%' }}>
      <>
        {skelRender
          .filter((f, i) => i < showCnt && f)
          .map(item => (
            <div
              key={item}
              style={{
                width: oneData ? '100%' : wrap ? (list ? `${100 / 2}%` : `100%`) : `${100 / skelRender.length}%`,
                display: display ? display : '',
                padding: '10px',
              }}
            >
              <Skeleton type='box' width={boxWidth} height={boxHeight} margin='0 0 10px' />
              <div style={{ width: wrap ? '50%' : '100%', padding: wrap ? '10px' : '0px' }}>
                <Skeleton type='text' width='80%' margin='5px 0' />
                <Skeleton type='text' width='60%' margin='5px 0' />
              </div>
            </div>
          ))}
      </>
    </Flex>
  );
};

export default VodListSkeleton;
